import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";

const MapPointContext = React.createContext({});
const MapPointStateProvider = MapPointContext.Provider;

function createPointFeature(coordinates, source) {
  return {
    type: "Feature",
    geometry: {
      type: "Point",
      coordinates,
    },
    properties: {
      source,
    },
  };
}

const MapPointContextProvider = ({ children }) => {
  const [activePointFeature, setActivePointFeature] = useState(undefined);

  const setActivePoint = (coordinates, source = "unknown") => {
    if (!Array.isArray(coordinates) || coordinates.length !== 2) {
      return;
    }

    setActivePointFeature(createPointFeature(coordinates, source));
  };

  const clearActivePoint = () => {
    setActivePointFeature(undefined);
  };

  const value = useMemo(
    () => ({
      activePointFeature,
      setActivePoint,
      clearActivePoint,
    }),
    [activePointFeature],
  );

  return (
    <MapPointStateProvider value={value}>{children}</MapPointStateProvider>
  );
};

MapPointContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { MapPointContext, MapPointContextProvider };
